var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alarm-time-list"},[_c('div',{staticClass:"device-name"},[_vm._v("灯控近七天在线率")]),_c('div',{staticClass:"tabList"},[_c('chartsLine',{key:_vm.setRefresh,attrs:{"option":_vm.lineData,"id":"QueryLightOnlineRate"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }